<template>
    <DefButtonPrimary
        :type="isDisabledConfirmButton ? 'button' : 'submit'"
        :class="{
            'disabled': isDisabledConfirmButton
        }"
        @click="handlerClick"
        class="checkout-confirm-button"
    >
        {{ messages.approve }}
    </DefButtonPrimary>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import DefButtonPrimary from "../def/DefButtonPrimary/DefButtonPrimary";

export default {
    name: 'CheckoutConfirmButton',
    components: {
        DefButtonPrimary,
    },
    computed: {
        ...mapState({
            messages: ({ checkout }) => checkout.data.vue.messages,
            delivery: ({ checkout }) => checkout.data.vue?.delivery,
            paySystem: ({ checkout }) => checkout.data.vue?.paySystem,
            orderType: ({ checkout }) => checkout.data.vue?.onOrder,
        }),
        ...mapGetters({
            getNotAvailableProductsIn1C: 'checkout/getNotAvailableProductsIn1C',
        }),
        getCheckedDelivery() {
            return Object.values(this.delivery.items).find(el => el.CHECKED === 'Y');
        },
        getCheckedPaySystem() {
            return Object.values(this.paySystem.items).find(el => el.CHECKED === 'Y');
        },
        isDisabledConfirmButton() {
            /** product isn't available in 1c  **/
            if (this.getNotAvailableProductsIn1C?.length) {
                return true;
            } else if (this.getCheckedDelivery.DISABLED || this.getCheckedPaySystem.DISABLED) {
                return true;
            } else if (this.getIPostDelivery?.CHECKED === 'Y' && !this.isAvailableIPost) {
                /** exceeded price limit in IPost **/
                return true;
            } else if (this.orderType === 'onOrder') {
                return true;
            }
        },
    },
    methods: {
        handlerClick(e) {
            const invalidInput = document.querySelector('input:invalid');

            if (this.isDisabledConfirmButton) {
                return e.preventDefault();
            }

            if (
                this.getNotAvailableProductsIn1C?.length
            ) {
                e.preventDefault();
                // changeOpenSmallBasket(true);
            } else if (invalidInput) {
                App.helpers.scrollPageTo(window.scrollY + invalidInput.getBoundingClientRect().top - 100);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.checkout-confirm-button{
    margin-top: 12px;
}
</style>